import React from 'react';

import styles from './ListItemDivider.module.scss';

export const ListItemDivider: React.SFC = () => (
  <div className={styles.listItemLineContainer}>
    <hr className={styles.listItemLineTop} />
    <hr className={styles.listItemLineBottom} />
  </div>
);
